import React, { useState } from "react"
import { navigate } from "gatsby"
import { useForm, ValidationError } from "@formspree/react"
import styles from "./contact.module.css"

const Contact = props => {
  const [state, handleSubmit] = useForm("newsletterForm")

  return (
    <div className={styles.FormWrapper} id="contact">
      <div className={styles.FormContainer}>
        <div className={styles.FormCopy}>
          <p>Subscribe to our newsletter:</p>
        </div>
        {state.succeeded ? (
          <div>Thanks for joining!</div>
        ) : (
          <form onSubmit={handleSubmit} className={styles.Form}>
            <div className={styles.Input}>
              <div className={styles.NameWrapper}>
                <label htmlFor="name" className={styles.Label}>
                  Name
                </label>
                <input
                  type="text"
                  name="name"
                  className={styles.Name}
                  required
                  maxLength="30"
                />
                <ValidationError
                  prefix="Name"
                  field="name"
                  errors={state.errors}
                />
              </div>
              <div className={styles.EmailWrapper}>
                <label htmlFor="email" className={styles.Label}>
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  className={styles.Email}
                  required
                  maxLength="50"
                />
                <ValidationError
                  prefix="Email"
                  field="email"
                  errors={state.errors}
                />
              </div>
            </div>
            <button
              className={styles.Button}
              type="submit"
              disabled={state.submitting}
            >
              Subscribe
            </button>
          </form>
        )}
      </div>
    </div>
  )
}

export default Contact
